'use strict';

module.exports = 0;



/*****************
 ** WEBPACK FOOTER
 ** ./~/shortid/lib/util/cluster-worker-id-browser.js
 ** module id = 4089
 ** module chunks = 0
 **/